<template>
  <div class="VisualizarOrcamentos">

    <el-row class="el-row-topo esconder_impressao">
      <el-col :span="22">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/orcamentos' }">Orçamentos</el-breadcrumb-item>
          <el-breadcrumb-item>Visualizar Orçamento</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button @click="imprimir">Imprimir</el-button>
      </el-col>
    </el-row>
<el-form :model="ruleForm" ref="ruleForm" :label-position="labelPosition">
    <el-row :gutter="10" type="flex" justify="center" style="margin-top:0px;">
      <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
        
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="espaco_top">
              <span class="label_campos">Nº do Negócio</span>
              <span>{{ruleForm.numero_negocio}}</span>
              <span class="label_campos label_separa">Revisão</span>
              <span>{{ruleForm.revisao}}</span>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="espaco_top">
              <span class="label_campos">Comissão Interna</span>
              <span>{{ruleForm.comissao}}</span>
              <span class="label_campos label_separa">Comissão Externa</span>
              <span>{{ruleForm.comissao_externa}}</span>
            </el-col>
          </el-row>
          <el-row :gutter="10" justify="left">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="espaco_top">
              <span class="label_campos">Cliente</span>
              <span>{{ruleForm.cliente}}</span>
            </el-col>
            <el-col :xs="24" :sm="16" :md="24" :lg="12" :xl="12" class="espaco_top">
              <span class="label_campos">Cidade</span>
              <span>{{ruleForm.cidade}}</span>
              <span class="label_campos label_separa">Estado</span>
              <span>{{ruleForm.estado}}</span>
            </el-col>
          </el-row>
</el-col>
    </el-row>
          <el-row>
            <el-col :span="23">
              <el-divider></el-divider>
            </el-col>
          </el-row>
    <el-row :gutter="10" type="flex" justify="center" >
      <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" class="espaco_top">
              <span class="label_campos">NCM</span>
              <span>{{ruleForm.ncm}}</span>
              <span class="label_campos label_separa">IPI</span>
              <span>{{ruleForm.ipi}}</span>
              <p>
                <span class="label_campos">Descrição NCM</span>
                <span>{{ruleForm.ncm_descricao}}</span>
              </p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
              <el-form-item label="Benefício PIS/COFINS?" prop="beneficio1">
                <el-switch
                  :disabled="true"
                  v-model="ruleForm.beneficio1"
                  active-text="Sim"
                  inactive-text="Não"
                  inactive-color="#66CC99"
                  active-color="#ff4949"
                ></el-switch>
              </el-form-item>

            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">

              <el-form-item label="Benefício IPI?" prop="beneficio4">
                <el-switch
                  :disabled="true"
                  v-model="ruleForm.beneficio4"
                  active-text="Sim"
                  inactive-text="Não"
                  inactive-color="#66CC99"
                  active-color="#ff4949"
                ></el-switch>
              </el-form-item>
              <el-form-item label="Tecnologia Digital?" prop="beneficio5">
                <el-switch
                  :disabled="true"
                  v-model="ruleForm.beneficio5"
                  inactive-color="#66CC99"
                  active-color="#ff4949"
                  active-text="Sim"
                  inactive-text="Não"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23" style=" margin-top:-30px; ">
              <el-divider></el-divider>
            </el-col>
          </el-row>
     
      </el-col>
    </el-row>
       </el-form>
    <el-form :model="ruleForm" ref="ruleForm" :label-position="labelPosition">
     <el-row :gutter="10" type="flex" justify="center" style="margin-top:20px;">
      <el-col :xs="24" :sm="24" :md="22" :lg="22" :xl="22">
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row style=" paddin:0px">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-row style="margin-top:0px;">
                    <el-col class="tabela_cmo" :span="24" style="margin-top:0px;">
                      <el-table
                        :data="listCmo"
                        style="width: 80%;margin-top:0px;"
                        :summary-method="getTotais"
                        show-summary
                      >
                        <el-table-column prop="funcao" label="Função" width="140">
                          <template slot-scope="scope">{{listCmo[scope.$index].funcao}}</template>
                        </el-table-column>
                        <el-table-column prop="hora_normal" label="Horas Normais">
                          <template slot-scope="scope">{{listCmo[scope.$index].hora_normal}}</template>
                        </el-table-column>
                        <el-table-column prop="hora_extra_50" label="Hr. Extra 50%">
                          <template slot-scope="scope">{{listCmo[scope.$index].hora_extra_50}}</template>
                        </el-table-column>
                        <el-table-column prop="hora_extra_100" label="Hr. Extra 100%">
                          <template slot-scope="scope">{{listCmo[scope.$index].hora_extra_100}}</template>
                        </el-table-column>
                        <el-table-column prop="total" label="Total" width="200px">
                          <template slot-scope="scope">{{listCmo[scope.$index].total}}</template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
 
                  <el-row>
                    <el-col :span="24">
                      <h4>Custos Diversos</h4>
                    </el-col>
                  </el-row>
                  <el-row >
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                      <span class="label_campos">ART</span>
                      <span>{{ruleForm.art}}</span>
                      <span class="label_campos label_separa">Outros</span>
                      <span>{{ruleForm.outros}}</span>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                      <span class="label_campos">Total</span>
                      <span>{{ruleForm.total_diversos}}</span>
                      <span class="label_campos label_separa">Total M.O.</span>
                      <span>{{ruleForm.totalGeral}}</span>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                      <span class="label_campos">Custo M.P.</span>
                      <span>{{ruleForm.cmp}}</span>
                      <span class="label_campos label_separa">Fat. Direto</span>
                      <span>{{ruleForm.faturamento_direto}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                      <span class="label_campos">Total M.P.</span>
                      <span>{{ruleForm.total_materia_prima}}</span>
                      <span class="label_campos label_separa">Custo Total</span>
                      <span>{{ruleForm.custo_total}}</span>
                    </el-col>                    
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-row>
                <el-col :xs="24" :sm="24" :md="20" :lg="24" :xl="24">
                  <h4 style=" margin-top:3px;">Custo Mão de Obra Painéis</h4>
                </el-col>
              </el-row>

              <el-row :gutter="10" type="flex" justify="center">
 

                <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
                  <el-table
                    :data="tab_tributos"
                    style="width: 311px"
                    show-summary
                    :summary-method="getTotaisTributos"
                  >
                    <el-table-column label="Tributos">
                      <el-table-column prop="descricao" label="Descrição" width="110"></el-table-column>
                      <el-table-column prop="percentual" label="Percentual" width="100"></el-table-column>
                      <el-table-column prop="valor" label="Valor" width="100"></el-table-column>
                    </el-table-column>
                  </el-table>
                  
                  <el-alert
                    v-if="mostra_msg_tecdig"
                    title="Tecnologia Digital!"
                    type="success"
                    :description="ruleForm.info_tecdig"
                    :closable="false"
                  ></el-alert>
                </el-col>
              </el-row>
              
              <el-divider></el-divider>
           <el-row :gutter="0">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">ICMS</span>
                  <span>{{tab_tributos[4].percentual}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">IPI</span>
                  <span>{{ruleForm.ipi}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="7" class="espaco_top">
                  <span class="label_campos">NCM</span>
                  <span>{{ruleForm.ncm}}</span>
                </el-col>
              </el-row>
              <el-row :gutter="0">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                  <span class="label_campos">Total Sem IPI</span>
                  <span>{{ruleForm.valor_venda_sem_ipi}}</span>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="espaco_top">
                  <span class="label_campos">Total Com IPI</span>
                  <span>{{ruleForm.valor_venda_com_ipi}}</span>
                </el-col>
              </el-row>              
            </el-col>
          </el-row>
      </el-col>
    </el-row>
    </el-form>
  </div>
</template>
<script>
//import { Money } from "v-money";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
    // Money,
  },

  data() {
    return {
      //////////////////PAINEIS////////////////////////////
      mostra_msg_tecdig:false,
      percentual_rentabilidade_desejada: 0,
      valor_rentabilidade_desejada: 0,
      valor_venda_sem_ipi: 0,
      valor_venda_com_ipi: 0,
      totalCusto: 0,
      totalTributos: 0,
      tab_custos: [
        {
          custo: "Matéria-Prima",
          valor: "0,00",
        },
        {
          custo: "Mão-de-Obra",
          valor: "0,00",
        },
        {
          custo: "Comissões",
          valor: "0,00",
        },
      ],
      tab_tributos: [
        {
          slug: "ipi",
          descricao: "IPI",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "irpj",
          descricao: "IRPJ",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "csll",
          descricao: "CSLL",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "pis_cofins",
          descricao: "PIS/COFINS",
          percentual: "0,00",
          valor: "0,00",
        },
        {
          slug: "icms",
          descricao: "ICMS",
          percentual: "0,00",
          valor: "0,00",
        },
      ],
  

      listCmo: [],
      ///fim select
      labelPosition: "right",
      ruleForm: {
        numero_negocio: "",
        revisao: "",
        comissao: "",
        comissao_externa: "",
        cliente: "",
        cidade: "",
        estado: "",
        rentabilidade: "",
        ncm: "",
        ncm_descricao: "",
        ipi: "",
        tec_dig_id: "",
        tec_dig_desc: "",
        beneficio1: false,
        beneficio2: false,
        beneficio3: false,
        beneficio4: false,
        beneficio5: false,
        art: "",
        outros: "",
        total_diversos: "",
        totalGeral: "",
        cmp: "", //custo materia-prima
        credito_pis_cofins: "",
        array_dados: [],
        valor_venda_sem_ipi:"",
        valor_venda_com_ipi:"",
        info_tecdig:"",
      },

    };
  },

  mounted() {

    if (this.$route.params.id) {
      axios
        .get(url + "/orcamentos/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.ruleForm.numero_negocio = resp.data.sge_orcamento;
            this.ruleForm.revisao = resp.data.revisao;
            this.ruleForm.comissao = resp.data.comissao;
            this.ruleForm.comissao_externa = resp.data.comissao_externa;
            this.ruleForm.cliente = resp.data.cliente;
            this.ruleForm.cidade = resp.data.cidade;
            this.ruleForm.estado = resp.data.estado;
            this.ruleForm.sge_cliente = resp.data.sge_cliente;
            this.ruleForm.sge_cidade = resp.data.sge_cidade;
            this.ruleForm.sge_estado = resp.data.sge_estado;
            this.ruleForm.rentabilidade = resp.data.rentabilidade;
            this.ruleForm.rentab_desejada = resp.data.rentabilidade;
            this.ruleForm.ncm_descricao = resp.data.ncm_descricao;
            this.ruleForm.ipi = resp.data.ncm_ipi;
            if (resp.data.ncm_ncm != undefined) {
              this.ruleForm.ncm =
                resp.data.ncm_ncm.substr(0, 4) +
                "." +
                resp.data.ncm_ncm.substr(4, 2) +
                "." +
                resp.data.ncm_ncm.substr(6, 2);
            }

            this.ruleForm.tec_dig_id = resp.data.tec_dig_id;
            this.ruleForm.tec_dig_desc = resp.data.tec_dig_desc;
            this.ruleForm.art = FuncoesUteis.formataDolarToReal(resp.data.art);
            this.ruleForm.outros = FuncoesUteis.formataDolarToReal(resp.data.outros);
            this.ruleForm.credito_pis_cofins = FuncoesUteis.formataDolarToReal(resp.data.credito_pis_cofins);
            this.ruleForm.cmp = FuncoesUteis.formataDolarToReal(resp.data.custo_materia_prima);
            this.ruleForm.total_diversos = FuncoesUteis.formataDolarToReal(resp.data.total_diversos);
            this.ruleForm.totalGeral = FuncoesUteis.formataDolarToReal(resp.data.totalGeral);
            this.ruleForm.total_materia_prima = FuncoesUteis.formataDolarToReal(resp.data.total_materia_prima);
            this.ruleForm.custo_total = FuncoesUteis.formataDolarToReal(resp.data.custo_total);
            this.ruleForm.faturamento_direto = FuncoesUteis.formataDolarToReal(resp.data.faturamento_direto);
            this.ruleForm.valor_venda_sem_ipi = FuncoesUteis.formataDolarToReal(resp.data.venda_sem_ipi);
            this.ruleForm.valor_venda_com_ipi = FuncoesUteis.formataDolarToReal(resp.data.venda_com_ipi);
            this.ruleForm.info_tecdig = resp.data.info_tecdig;
            
              if (this.ruleForm.info_tecdig != ''){
                this.mostra_msg_tecdig = true;
              } else {
                this.mostra_msg_tecdig = false
              }

            if (resp.data.beneficio_pis_cofins == 1) {
              this.ruleForm.beneficio1 = true;
            } else {
              this.ruleForm.beneficio1 = false;
            }
            if (resp.data.beneficio_irpj == 1) {
              this.ruleForm.beneficio2 = true;
            } else {
              this.ruleForm.beneficio2 = false;
            }
            if (resp.data.beneficio_csll == 1) {
              this.ruleForm.beneficio3 = true;
            } else {
              this.ruleForm.beneficio3 = false;
            }
            if (resp.data.beneficio_ipi == 1) {
              this.ruleForm.beneficio4 = true;
            } else {
              this.ruleForm.beneficio4 = false;
            }
            if (resp.data.beneficio_tec_dig == 1) {
              this.ruleForm.beneficio5 = true;
            } else {
              this.ruleForm.beneficio5 = false;
            }
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });


     axios
        .get(url + "/list_projcmo/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listCmo = resp.data;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });        
     

     axios
        .get(url + "/list_projtributos/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            for(let i=0;i<resp.data.length;i++){
              for(let x=0;x<this.tab_tributos.length;x++){
                  if(resp.data[i].slug == this.tab_tributos[x].slug){
                    this.tab_tributos[x].percentual = FuncoesUteis.formataDolarToReal(resp.data[i].percentual);
                    this.tab_tributos[x].valor = FuncoesUteis.formataDolarToReal(resp.data[i].valor);
                  }
              }
              
            }

          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });        
    }
   
  },
methods:{
  imprimir(){
    print();
  },
    getTotaisCustos(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 1) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            let vl = new String(dados[i]);
            vl = vl.replace(".", "");
            vl = vl.replace(",", ".");
            dados[i] = vl;
            sums[index] += parseFloat(dados[i]);
          }
          this.totalCusto = sums[index];
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
      });
    //  this.somaVenda();
      return sums;
    },
    getTotaisTributos(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 1) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            dados[i] = FuncoesUteis.formataRealToDolar(dados[i]);
            sums[index] += parseFloat(dados[i]);
          }
          this.totalTributos = sums[index];
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
        if (index === 2) {
          let dados = data.map((item) => item[column.property]);
          sums[index] = 0;
          for (let i = 0; i < dados.length; i++) {
            dados[i] = FuncoesUteis.formataRealToDolar(dados[i]);
            sums[index] += parseFloat(dados[i]);
          }
          sums[index] = FuncoesUteis.formataDolarToReal(sums[index]);
        }
      });
     // this.somaVenda();
      return sums;
    },
    /////////////////////////////////////////////////////////

    getTotais(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totais";
          return;
        }
        let dados = data.map((item) => item[column.property]);
        if (index === 1) {
          sums[index] = "";
        }

        if (index > 1 && index < 5) {
          for (let i = 0; i < dados.length; i++) {
            if (sums[index] === undefined) {
              sums[index] = 0;
            }

            if (dados[i] == "") {
              dados[i] = 0;
            } else if (dados[i] == null) {
              dados[i] = 0;
            }
            sums[index] += parseFloat(dados[i]);
          }
        }
        if (index === 5) {
          for (let i = 0; i < dados.length; i++) {
            if (sums[index] === undefined) {
              sums[index] = 0;
            } else if (sums[index] === "") {
              sums[index] = 0;
            } else if (isNaN(sums[index])) {
              sums[index] = 0;
            }

            let vl = new String(dados[i]);
            vl = vl.replace(".", "");
            vl = vl.replace(",", ".");
            dados[i] = vl;
            sums[index] += parseFloat(dados[i]);
          }
          if (isNaN(sums[index])) {
            sums[index] = 0;
          } else {
            sums[index] = parseFloat(sums[index]);
            sums[index] = sums[index].toFixed(2);
            let vl = new String(sums[index]);
            vl = vl.replace(",", "");
            vl = vl.replace(".", ",");
            sums[index] = vl;
          }
        }
      });

      //////soma o total geral/////
      this.tab_custos[0].valor = this.ruleForm.cmp;
      return sums;
    },
}
};
</script>
<style>
.bg-purple-light {
  background: #303133;
}
.VisualizarOrcamentos .grid-content {
  border-radius: 4px;
  min-height: 2px;
  height: 2px;
}

.tec_select label {
  width: 100%;
  text-align: left;
}
.tec_select div {
  width: 100%;
  text-align: left;
}
.encontrar_orc_left {
  text-align: left;
}
.lista_ncm {
  text-align: left;
  margin-bottom: 0px;
  margin-top: 10px;
}

.VisualizarOrcamentos .el-table td,
.el-table th {
  padding: 0px 0 !important;
}
.tabela_cmo .item {
  margin-bottom: 0px !important;
}
.VisualizarOrcamentos form span {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 3px 10px;
  font-style: italic;
}
.VisualizarOrcamentos .el-switch span {
  border: 0px;
  border-radius: 30px;
}

.VisualizarOrcamentos .label_campos {
  font-weight: bold;
  border: 0px;
}
.VisualizarOrcamentos .label_separa {
  margin-left: 30px;
}
.VisualizarOrcamentos .espaco_top {
  margin-top: 20px;
  text-align: left;
  padding: 5px 0px;
}
</style>